import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NavigationBar } from "../../Components/NavigationBar/NavigationBar";
import { ModalMessage } from "../../Components/ModalMessage/ModalMessage";
import { useChangePassword } from "../../hooks/useChangePassword";
import "../../Components/Login/Login.css";

const ChangePasswordPage = () => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const { changePassword, loading, error, success } = useChangePassword();
    const navigate = useNavigate();

    useEffect(() => {
        if (success) {
            setShowSuccessModal(true);
        }
    }, [success]);

    const handleSubmit = () => {
        setPasswordError("");
        if (newPassword !== confirmPassword) {
            setPasswordError("As senhas não conferem");
            return;
        }
        changePassword({ currentPassword, newPassword });
    };

    const handleBack = () => {
        navigate('/profile');
    };

    return (
        <div className="login-container">
            <NavigationBar onBackClick={handleBack} title="Alterar Senha" />
            <img src="/imgs/reino_header_logo.svg" alt="Reinoplay Logo" className="login-logo" />
            <form className="login-form-vertical" onSubmit={e => { e.preventDefault(); handleSubmit(); }}>
                    <input
                        type="password"
                        placeholder="Senha atual"
                        className="login-input"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Nova senha"
                        className="login-input"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Confirmar nova senha"
                        className="login-input"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {(error || passwordError) && (
                        <p className="login-error-message">
                            {passwordError || error}
                        </p>
                    )}
                    <button
                        className="login-button"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? "Alterando..." : "Alterar senha"}
                    </button>
                </form>
            {showSuccessModal && (
                <ModalMessage
                    title="Senha alterada"
                    description="Sua senha foi alterada com sucesso!"
                    leftButtonText="OK"
                    leftButtonAction={() => {
                        setShowSuccessModal(false);
                        navigate('/profile');
                    }}
                    rightButtonText="Cancelar"
                    rightButtonAction={() => {
                        setShowSuccessModal(false);
                        navigate('/profile');
                    }}
                />
            )}
        </div>
    );
};

export default ChangePasswordPage;
